import { SvgIcon, SvgIconProps } from '@mui/material';

const LocalStateIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40" fill="none">
      <mask
        id="mask0_2012_90"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="40"
      >
        <rect width="40" height="40" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_2012_90)">
        <path
          d="M20.5556 18.1667H23.3335V14.7221H26.7781V11.9446H23.3335V8.50001H20.5556V11.9446H17.1114V14.7221H20.5556V18.1667ZM17.1114 24.7221H26.7781V21.9446H17.1114V24.7221ZM11.6668 32.7779C10.9168 32.7779 10.2664 32.5024 9.71558 31.9513C9.16447 31.4004 8.88891 30.75 8.88891 30V4.44459C8.88891 3.69459 9.16447 3.04403 9.71558 2.49292C10.2664 1.94209 10.9168 1.66667 11.6668 1.66667H25.2222L35.0002 11.4446V30C35.0002 30.75 34.7247 31.4004 34.1739 31.9513C33.6228 32.5024 32.9722 32.7779 32.2222 32.7779H11.6668ZM6.11141 38.3333C5.36141 38.3333 4.71086 38.0579 4.15975 37.5071C3.60891 36.956 3.3335 36.3054 3.3335 35.5554V10.5833H6.11141V35.5554H26.0556V38.3333H6.11141Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};

export default LocalStateIcon;
